import React from "react";
import { Btn } from "./ui";
import { LINKS, CONTACT } from "./data";
import { Phone, Mail } from "lucide-react";

export const ContactSection = () => (
  <section id="contact" className="py-16 lg:py-24 bg-[#2D2D37]">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <h2 className="font-heading font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-[2.75rem] leading-tight text-white">
        Ready to Make Your Next Move?
      </h2>
      <p className="mt-6 text-base sm:text-lg leading-relaxed text-white/75 max-w-2xl mx-auto">
        Whether you are searching for a home, thinking about selling, or looking for a brokerage
        to grow with, Wallstreet Realty is ready to help.
      </p>

      <div className="mt-10 flex flex-wrap justify-center gap-3">
        <Btn href={LINKS.idx} variant="primary" testid="contact-search-homes" pill>Search Homes</Btn>
        <Btn href={LINKS.buyers} variant="gold" testid="contact-book-consultation">Book Buyer Consultation</Btn>
        <Btn href={LINKS.join} variant="outlineLight" testid="contact-apply-join">Apply to Join</Btn>
        <Btn href={LINKS.sellers} variant="ghostGold" testid="contact-home-value">Get My Home Value</Btn>
      </div>

      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <a
          href={`tel:${CONTACT.phoneTel}`}
          data-testid="contact-call-now"
          className="inline-flex items-center gap-2 text-white/90 hover:text-[#C9A961] transition-colors font-medium border border-white/20 rounded-lg px-5 py-3"
        >
          <Phone size={17} /> Call Now: {CONTACT.phone}        
        </a>
        <a
          href={`mailto:${CONTACT.email}`}
          data-testid="contact-email-us"
          className="inline-flex items-center gap-2 text-white/90 hover:text-[#C9A961] transition-colors font-medium border border-white/20 rounded-lg px-5 py-3"
        >
          <Mail size={17} /> Email Us: {CONTACT.email}
        </a>
      </div>
      <p className="mt-6 text-sm text-white/45">{CONTACT.address}</p>
    </div>
  </section>
);
